import React from "react";

import {
    Wrapper,
    Grid,
    Card,
    Header,
    Image,
    Info,
    Line,
    Section,
    Label,
    Input,
    Chips,
    Chip,
    Pagination,
    Summary,
    Pages,
    Page,
    Rows,
} from "./PrinterGridShimmer.styles";

const CARD_COUNT = 6;
const CHIP_COUNT = 3;
const PAGE_COUNT = 4;

const LINE_CONFIG: ReadonlyArray<{
    width: string;
    height?: number;
}> = [{ width: "80%", height: 20 }, { width: "60%" }, { width: "45%" }];

const PrinterGridShimmer: React.FC = () => (
    <Wrapper>
        <Grid>
            {Array.from({ length: CARD_COUNT }, (_, cardIndex) => (
                <Card key={cardIndex}>
                    <Header>
                        <Image />
                        <Info>
                            {LINE_CONFIG.map(({ width, height }) => (
                                <Line key={width} width={width} height={height} />
                            ))}
                        </Info>
                    </Header>
                    <Section>
                        <Label />
                        <Input />
                    </Section>
                    <Section>
                        <Label />
                        <Chips>
                            {Array.from({ length: CHIP_COUNT }, (_chip, chipIndex) => (
                                <Chip key={chipIndex} />
                            ))}
                        </Chips>
                    </Section>
                </Card>
            ))}
        </Grid>
        <Pagination>
            <Summary />
            <Pages>
                {Array.from({ length: PAGE_COUNT }, (_page, pageIndex) => (
                    <Page key={pageIndex} />
                ))}
            </Pages>
            <Rows />
        </Pagination>
    </Wrapper>
);

export default React.memo(PrinterGridShimmer);
